<template>
  <div>
    <div class="col-md-12">
      <div class="row distant-bottom" v-if="escalation_process.id !== 0">
        <div class="col-md-12">
          {{ $t("escalationprocess.editdetail") }}:
          <b>#{{ escalation_process.id }}</b>
        </div>
      </div>

      <div class="row distant-bottom">
        <div class="col-md-2">
          <span class="title">{{ $t("escalationprocess.name") }}:</span>
        </div>
        <div class="col-md-5">
          <input
            v-model="escalation_process.name"
            type="text"
            class="form-control"
          />
        </div>
      </div>

      <div class="row distant-bottom">
        <div class="col-md-2">{{ $t("escalationstage.name") }}:</div>

        <div class="col-md-10">
          <div class="content-layout" style="float:left;">
            <ul class="remove-default">
              <li
                class="item"
                v-for="(stage, index) in escalation_state_items"
                :key="stage.index"
                @click="setTargetStages(stage, index)"
                :class="{ disabled: targetStageOptions.indexOf(stage) > -1 }"
              >
                {{ stage.name }}
              </li>
            </ul>
          </div>
          <div class="div-center">
            <div class="right-arrow div-arrow">
              <i class="fa fa-fw fa-arrow-right"></i>
            </div>
          </div>
          <div class="content-layout">
            <ul class="remove-default">
              <li
                class="item"
                v-for="(stage, index) in targetStageOptions"
                :key="stage.index"
                @click="unsetTargetStages(stage, index)"
              >
                {{ stage.name }}
              </li>
            </ul>
          </div>
          <div>
            <i>(*){{ $t("escalationprocess.stagenote") }}</i>
          </div>
        </div>
      </div>

      <div class="row distant-bottom">
        <div class="col-md-2"></div>

        <div class="col-md-5">
          <button
            type="button"
            class="btn btn-labeled btn-danger"
            @click="onCancelStage"
            style="background-color: #f29911;border-color: #f29911;color:#fff"
          >
            <span class="btn-label"> <i class="fa fa-mail-reply"></i> </span>
            {{ $t("common.back") }}
          </button>
          <button
            v-if="
              GET_ACCOUNT_DATA.id == 1 ||
                has_perm('create_case_escalation_process')
            "
            type="button"
            class="btn btn-labeled btn-success"
            @click="onSaveStage"
          >
            <span class="btn-label">
              <i class="glyphicon glyphicon-ok"></i>
            </span>
            {{ $t("common.save") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import utils from '@/lib/utils';

export default {
  name: "EscalationProcessInput",
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      targetStageOptions: [],
      escalation_process: {
        id: 0,
        name: "",
        stages: []
      }
    };
  },
  watch: {
    item: function() {
      this.create();
      if (this.item.id === 0) {
        // new
        this.targetStageOptions = [];
      } else {
        // update
        let stages = [];
        this.item.stages.forEach(v => {
          let stage = this.escalation_state_items.filter(stage => {
            if (stage.id == v.stage_details.id) {
              return true;
            }
          })[0];
          stages.push(stage);
        });
        this.targetStageOptions = stages;
      }
    }
  },
  computed: {
    ...mapGetters([
      "ESCALATION_STAGE_LIST",
      "GET_ACCOUNT_DATA"
    ]),
    escalation_state_items: function() {
      let items = [];
      this.ESCALATION_STAGE_LIST.forEach(v => {
        let id = v.id;
        let name = v.name;
        //let stages = v.stages
        let item = {
          id: id,
          name: name
          //stages: stages
        };
        items.push(item);
      });
      return items;
    }
  },
  methods: {
    ...mapActions([]),
    create() {
      this.escalation_process.id = this.item.id;
      this.escalation_process.name = this.item.name;
      this.escalation_process.stages = this.item.stages;
    },
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    setTargetStages(stage, index) {
      this.targetStageOptions.push(stage);
    },
    unsetTargetStages(stage, index) {
      this.targetStageOptions.splice(index, 1);
    },
    onSaveStage() {
      let stages = [];
      this.targetStageOptions.forEach(v => {
        let item = {
          escalation_stage: v.id
        };
        stages.push(item);
      });
      this.escalation_process.stages = stages;
      this.$emit("save", this.escalation_process);
    },
    onCancelStage() {
      this.$emit("close", {});
    }
  },
  mounted() {
    this.create();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.pool-area {
  width: 40%;
}

ul.remove-default {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.right-arrow {
  text-align: center;
  width: 10%;
  display: inline-block;
}

.content-layout {
  border: 1px solid #ccc;
  width: 40%;
  height: 170px;
  overflow: auto;
  display: inline-block;
  padding: 0.05em 5px;
}

li.item {
  border-bottom: 1px solid #eee;
  padding: 10px;
  cursor: pointer;
}

li.item:hover {
  background: #f4f4f4;
}

.disabled {
  pointer-events: none;
  opacity: 0.6;
}

.distant-bottom {
  margin-bottom: 10px;
}
.div-center {
  float: left;
  width: 7%;
  height: 170px;
}
.div-arrow {
  float: left;
  width: 100%;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}
</style>



// WEBPACK FOOTER //
// src/views/Case/EscalationProcessInput.vue